const GRADE_COLOR_POOR = '#ff4d4f';
const GRADE_COLOR_MEDIOCRE = '#faad14';
const GRADE_COLOR_GOOD = '#a0d911';
const GRADE_COLOR_GREAT = '#52c41a';

// Сплошной цвет по значению, а не градиент вдоль дуги — градиент вводит в
// заблуждение, так как непонятно, где на дуге начало, а где конец шкалы.
export const getGradeColor = (grade: number): string => {
  if (grade < 40) return GRADE_COLOR_POOR;
  if (grade < 60) return GRADE_COLOR_MEDIOCRE;
  if (grade < 80) return GRADE_COLOR_GOOD;
  return GRADE_COLOR_GREAT;
};
